export default "__VITE_ASSET__CnpNCmqk__"